import { location } from "../../data/Fleet/Location";

export const settlementPayeeFieldConfiguration = [
  {
    name: "payeeCode",
    label: "Payee Code",
    type: "text",
    validation: {
      required: "Payee code is required",
      minLength: {
        value: 1,
        message: "Payee code must be at least 1 character long",
      },
      maxLength: {
        value: 30,
        message: "Payee code must not exceed 30 characters",
      },
    },
  },
  {
    name: "name",
    label: "Company name",
    type: "text",
    validation: {
      required: "Company name is required",
      minLength: {
        value: 2,
        message: "Name must be at least 2 characters long",
      },
      maxLength: {
        value: 50,
        message: "Name must not exceed 50 characters",
      },
    },
  },
  {
    name: "address",
    label: "Address",
    type: "text",
    validation: {
      required: "Address is required",
      minLength: {
        value: 5,
        message: "Address must be at least 5 characters long",
      },
      maxLength: {
        value: 150,
        message: "Address must not exceed 150 characters",
      },
    },
  },
  {
    name: "city",
    label: "City",
    type: "text",
    validation: {
      required: "City is required",
      minLength: {
        value: 2,
        message: "City must be at least 2 characters long",
      },
      maxLength: {
        value: 50,
        message: "City must not exceed 50 characters",
      },
    },
  },
  {
    name: "state",
    label: "State",
    type: "select",
    options: location,
    validation: {
      required: "State is required",
    },
  },
  {
    name: "zipCode",
    label: "Zip Code",
    type: "text",
    validation: {
      required: "Zip code is required",
      pattern: {
        value: /^\d{5}$/,
        message: "Zip code must be 5 digits",
      },
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone number is required",
    },
  },
  {
    name: "emailAddress",
    label: "Email Address",
    type: "text",
    validation: {
      required: "Email address is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Email address must be in the format",
      },
    },
  },
];

export const settlementPayeeInitialValues = {
  payeeCode: "",
  name: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  phoneNumber: "",
  emailAddress: "",
};
